<template>
  <kst-page-edit autoValidate
    @init="handleInit"
    @submit="handleSubmit"
  >
    <Details
      :debtPayData="debtPayData"
      :userData="userData"
    />
    <DebtPay :debtPayData="debtPayData"/>
  </kst-page-edit>
</template>

<script>
import InputPageMixin from "../../../mixins/InputPageMixin.js";
import Model from "../DbpyModel.js";
import Services from "../../../services/Api/DebtPayServices.js";

import DebtPay from "./DbpyES_DebtPay.vue";
import Details from "./DbpyES_Details.vue";

export default {
  mixins: [InputPageMixin],
  components: {
    DebtPay,
    Details
  },
  data: () => ({
    debtPayData: {},
    userData: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadEdit) {
      this.resetData();

      const config = Services.getEditStatusData(id);
      loadEdit(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.debtPayData = data.Details;
      Model.setDetailsByStatus(this.debtPayData);

      Model.EditStatus.setDetailsByEditData(this.userData, this.debtPayData);
      Model.setDetailsByStatus(this.userData);
    },

    handleSubmit(saveData) {
      let data = Model.EditStatus.populateData(this.userData);
      const config = Services.putStatus(data);
      saveData(config, this.handleSubmit_Success);
    },
    handleSubmit_Success() {
      this.disableRouteLeave();
    },

    /*** custom ***/

    resetData() {
      this.debtPayData = {};
      this.userData = Model.createDetails();
    }
  }
}
</script>